import { useEffect, useState } from 'react'
import { acquireToken, getActiveAccount } from './msal.js'

/**
 * useAuth — State-Machine für die NAA-Anmeldung.
 *
 * Vier Zustände:
 *   - status='idle'    → noch nichts versucht (Initial-Zustand vor Effekt-Lauf)
 *   - status='loading' → Token wird gerade geholt
 *   - status='ready'   → Token + Account-Info verfügbar
 *   - status='error'   → Fehler beim Holen, mit code + message
 *
 * Der Hook startet beim Mount automatisch ein acquireToken().
 *
 * Wichtig: Im Standalone-Mode (Browser ohne Office-Host) wird
 * acquireTokenSilent fehlschlagen, dann fällt MSAL.js auf
 * acquireTokenPopup zurück. Das öffnet ein Microsoft-Login-Fenster —
 * für ein Office-Add-in unter Outlook ist das im Normalfall NICHT nötig
 * (NAA holt das Token aus der Host-Session), aber im Standalone-Modus
 * (DevTools / direkt im Browser) ist das die einzige Auth-Option.
 */
export function useAuth() {
  const [state, setState] = useState({ status: 'idle' })

  useEffect(() => {
    let cancelled = false
    setState({ status: 'loading' })

    ;(async () => {
      try {
        const tokenResult = await acquireToken()
        const account = await getActiveAccount()
        if (cancelled) return
        setState({
          status: 'ready',
          accessToken: tokenResult.accessToken,
          account,
          expiresOn: tokenResult.expiresOn,
        })
      } catch (err) {
        if (cancelled) return
        // MSAL-Errors haben oft errorCode, manchmal nur message.
        const code = err?.errorCode || err?.code || 'auth_failed'
        const message =
          err?.errorMessage || err?.message || 'Anmeldung fehlgeschlagen'
        // eslint-disable-next-line no-console
        console.error('[useAuth] acquireToken failed', err)
        setState({ status: 'error', code, message })
      }
    })()

    return () => {
      cancelled = true
    }
  }, [])

  return state
}
